<div class="datepicker-container">
    <input #dateInput type="text" [(ngModel)]="localDateString" placeholder="MM/DD/YYYY hh:mm:ss AM/PM" style="width: 100%;"/>
</div>